import { SetShowHowToPlay } from "./types";

export function howToPlay(
  setShowHowToPlay: SetShowHowToPlay,
  showHowToPlay: boolean
) {
  setShowHowToPlay(showHowToPlay ? false : true);
}
